import React from "react";
import AdminNewsGet from "./AdminNewsComps/AdminNewsGet";
import AdminAdSectionGet from "./AdminNewsComps/AdminAdSectionGet";
import AdminAdTopSectionGet from "./AdminNewsComps/AdminAdTopSectionGet";
import AdminNewsCreate from "./AdminNewsComps/AdminNewsCreate";

export default function AdminNewsMP() {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <a
        style={{
          marginTop: 20,
          paddingBottom: 20,
          fontSize: 20,
          fontWeight: 500,
        }}
      >
        News Page
      </a>
      <AdminNewsCreate />
      <AdminNewsGet />
      <AdminAdSectionGet />
      <AdminAdTopSectionGet />
    </div>
  );
}
